module.exports = __webpack_public_path__ + "KaTeX_AMS-Regular.b51a6c5d.ttf";